import { StringUnionKeyAsValue } from '~src/commonInfra/utils/TypescriptHelpers';

export type RequestAccessType = 'project' | 'view' | 'workbook'| 'datasource' | 'flow' | 'collection' | 'virtualConnection' | 'virtualConnectionTable';

export const RequestAccessTypeValue: StringUnionKeyAsValue<RequestAccessType> = {
  project: 'project',
  workbook: 'workbook',
  view: 'view',
  datasource: 'datasource',
  flow: 'flow',
  collection: 'collection',
  virtualConnection: 'virtualConnection',
  virtualConnectionTable: 'virtualConnectionTable'
};
